import en from 'element-ui/lib/locale/lang/en';
import jp from 'element-ui/lib/locale/lang/ja';
import cn from 'element-ui/lib/locale/lang/zh-CN';
import tw from 'element-ui/lib/locale/lang/zh-TW';
import locale from 'element-ui/lib/locale';
import _ from 'lodash';
import { injectService } from '@/inversify.config';
import { i18nSymbol } from '@/i18n';
export const labI18n = {
    en: {
        'lab.workspace.pin': 'Pin',
        'lab.workspace.labDesc': 'Workspace Pin',
        'lab.workspace.unpin': 'Unpin',
        'lab.workspace.toolbar.wordcloud': 'Word Cloud',
        'lab.workspace.patent_color': 'Patent Color',
        'lab.workspace.filter_color_mode': 'Filter Mode',
        'lab.encryption.Decryption': 'Decryption',
        'lab.encryption.Encryption': 'Encryption',
        'lab.encryption.Password': 'Password',
        'lab.encryption.ConfirmPassword': 'Confirm password',
        'lab.encryption.CanclePassword': 'Cancel password',
        'lab.encryption.InputPassword': 'Please enter the password',
        'lab.encryption.NoSame': 'The passwords are inconsistent. Please re-enter them',
        'lab.encryption.passwordPrompt': 'Password prompt',
        'lab.encryption.passwordPromptMessage': 'Please enter a password prompt.',
        'lab.encryption.promptMessage': 'Please enter a suggestive text within 10 characters.',
        'lab.encryption.CancleSeccuss': 'Succeeded in canceling the password.',
        'lab.encryption.EncryptionSuccess': 'Encryption success',
        'lab.encryption.DecryptionSuccess': 'Decryption success',
        'lab.liteTable.title': 'Lite Table',
    },
    jp: {
        'lab.workspace.pin': '固定',
        'lab.workspace.labDesc': 'ワークスペース固定',
        'lab.workspace.unpin': '固定解除',
        'lab.workspace.toolbar.wordcloud': 'ワードクラウドビュー',
        'lab.workspace.patent_color': 'パテントカラー',
        'lab.workspace.filter_color_mode': 'フィルターモード',
        'lab.encryption.Decryption': '復号',
        'lab.encryption.Encryption': '暗号化',
        'lab.encryption.Password': 'パスワード',
        'lab.encryption.ConfirmPassword': 'パスワードを確認する',
        'lab.encryption.CanclePassword': 'パスワードをキャンセル',
        'lab.encryption.InputPassword': 'パスワードを入力してください',
        'lab.encryption.NoSame': 'パスワードが一致しません。もう一度入力してください',
        'lab.encryption.passwordPrompt': 'パスワードのヒント',
        'lab.encryption.passwordPromptMessage': 'パスワードのヒントを入力してください',
        'lab.encryption.promptMessage': '10文字以内のヒントテキストを入力してください',
        'lab.encryption.CancleSeccuss': 'パスワードのキャンセルに成功しました',
        'lab.encryption.EncryptionSuccess': '暗号化に成功しました',
        'lab.encryption.DecryptionSuccess': '復号に成功しました',
        'lab.liteTable.title': '表ビューLite版',
    },
    cn: {
        'lab.workspace.pin': '置顶',
        'lab.workspace.labDesc': '工作空间置顶',
        'lab.workspace.unpin': '取消置顶',
        'lab.workspace.toolbar.wordcloud': '词云视图',
        'lab.workspace.patent_color': '专利颜色',
        'lab.workspace.filter_color_mode': '筛选模式',
        'lab.encryption.Decryption': '解密',
        'lab.encryption.Encryption': '加密',
        'lab.encryption.Password': '密码',
        'lab.encryption.ConfirmPassword': '确认密码',
        'lab.encryption.CanclePassword': '取消密码',
        'lab.encryption.InputPassword': '请输入密码',
        'lab.encryption.NoSame': '密码不一致,请重新输入',
        'lab.encryption.passwordPrompt': '密码提示',
        'lab.encryption.passwordPromptMessage': '请输入密码提示',
        'lab.encryption.promptMessage': '请输入10个字符内的提示性文字',
        'lab.encryption.CancleSeccuss': '取消密码成功',
        'lab.encryption.EncryptionSuccess': '加密成功',
        'lab.encryption.DecryptionSuccess': '解密成功',
        'lab.liteTable.title': '表格视图Lite版',
    },
    tw: {
        'lab.workspace.pin': '置頂',
        'lab.workspace.labDesc': '工作空間置頂',
        'lab.workspace.unpin': '取消置頂',
        'lab.workspace.toolbar.wordcloud': '詞雲視圖',
        'lab.workspace.patent_color': '專利顏色',
        'lab.workspace.filter_color_mode': '篩選模式',
        'lab.encryption.Decryption': '解密',
        'lab.encryption.Encryption': '加密',
        'lab.encryption.Password': '密碼',
        'lab.encryption.ConfirmPassword': '確認密碼',
        'lab.encryption.CanclePassword': '取消密碼',
        'lab.encryption.InputPassword': '請輸入密碼',
        'lab.encryption.NoSame': '密碼不一致,請重新輸入',
        'lab.encryption.passwordPrompt': '密碼提示',
        'lab.encryption.passwordPromptMessage': '請輸入密碼提示',
        'lab.encryption.promptMessage': '請輸入十個字符內的提示性文字',
        'lab.encryption.CancleSeccuss': '取消密碼成功',
        'lab.encryption.EncryptionSuccess': '加密成功',
        'lab.encryption.DecryptionSuccess': '解密成功',
        'lab.liteTable.title': '表格視圖Lite版',
    },
};
export const initExtendI18n = () => {
    const i18n = injectService(i18nSymbol);
    const _element_ui_locales = ({ en, jp, cn, tw }[i18n.locale]) || en;
    const _locales = _.merge({}, _element_ui_locales);
    locale.use(_locales);
    i18n.mergeLocaleMessage(i18n.locale, labI18n[i18n.locale]);
};
